module.exports = __webpack_public_path__ + "img/42.7721e12b.jpg";